module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 15s-.4-7.8-7-10V1L1 8l7 7v-4c5.1 0 7 4 7 4z\"></path></svg>"